import TCGdex from "./tcgdex"

module.exports = TCGdex
